
export const constUsers = [
    {
        userName: 'Постнов Игорь', 
        department: 'Технический директор',
        id: 1,
        salary: 100000,
        avatar: 'https://img.freepik.com/free-photo/portrait-of-cheerful-caucasian-man_53876-13440.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Возвратная Екатерина', 
        department: 'HR',
        id: 2,
        salary: 60000,
        avatar: 'https://img.freepik.com/free-photo/young-and-beautiful-woman-in-pink-warm-sweater-natural-look-smiling-portrait-on-isolated-long-hair_285396-896.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Николаев Николай', 
        department: 'Дизайнер',
        id: 3,
        salary: 60000,
        avatar: 'https://img.freepik.com/premium-photo/headpshot-portrait-of-young-happy-unshaven-man-in-white-tshirt-looking-at-camera-with-excited-facial-expresson-while-posing-against-blue-studio-background-human-emotions-and-positivity-concept_95891-4187.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Петров Петр', 
        department: 'Маркетинг',
        id: 4,
        salary: 30000,
        avatar: 'https://img.freepik.com/free-photo/bearded-young-man-wearing-shirt_273609-5938.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Сидоров Павел', 
        department: 'Финансы',
        id: 5,
        salary: 100000,
        avatar: 'https://img.freepik.com/premium-photo/positive-young-guy-with-red-beard-in-bright-orange-sweatshirt-looking-into-camera-and-smiling-on-isolated-blue-background_197531-27744.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Комаров Роман', 
        department: 'Frontend разработчик',
        id: 6,
        salary: 60000,
        avatar: 'https://img.freepik.com/free-photo/handsome-and-sensitive-red-head-man-smiling_23-2149509800.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Петров Иван', 
        department: 'Маркетинг',
        id: 7,
        salary: 20000,
        avatar: 'https://img.freepik.com/premium-photo/portrait-smile-and-man-with-positive-confidence-and-carefree-against-a-grey-studio-background-face-male-person-and-human-with-a-cheerful-attitude-freedom-and-model-with-joy-canada-and-relax_590464-177008.jpg?size=626&ext=jpg&ga=GA1.1.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Сергеева Екатерина', 
        department: 'Frontend разработчик',
        id: 8,
        salary: 30000,
        avatar: 'https://img.freepik.com/free-photo/isolated-shot-of-pleasant-looking-young-woman-wears-white-turtleneck-has-hair-bun-looks-with-calm-facial-expressions-poses-against-pink-background_273609-32162.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Васин Петр', 
        department: 'Backend разработчик',
        id: 9,
        salary: 100000,
        avatar: 'https://img.freepik.com/premium-photo/close-up-of-handsome-caucasian-man-smiling-at-camera-looking-confident-wearing-orange-sweater-standing-against-turquoise-background_1258-45706.jpg?size=626&ext=jpg&ga=GA1.1.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Николаева Светлана', 
        department: 'Frontend разработчик',
        id: 10,
        salary: 60000,
        avatar: 'https://img.freepik.com/premium-photo/woman-portrait-confidence-brunette-dressed-brown-turtleneck-with-dramatic-atmosphere_91014-4435.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Смирнов Петр', 
        department: 'Тестировщик',
        id: 11,
        salary: 20000,
        avatar: 'https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Смирнов Иван', 
        department: 'Backend разработчик',
        id: 12,
        salary: 30000,
        avatar: 'https://img.freepik.com/free-photo/happy-bearded-young-man-looks-with-joyful-expression-has-friendly-smile-wears-yellow-sweater-and-red-hat_295783-1388.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Смирнова Мария', 
        department: 'Тестировщик',
        id: 13,
        salary: 100000,
        avatar: 'https://img.freepik.com/premium-photo/woman-cheerful-studio-portrait-concept_53876-79555.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Костин Иван', 
        department: 'Backend разработчик',
        id: 14,
        salary: 60000,
        avatar: 'https://img.freepik.com/free-photo/portrait-man-laughing_23-2148859448.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Воронина Ирина', 
        department: 'Финансы',
        id: 15,
        salary: 20000,
        avatar: 'https://img.freepik.com/free-photo/close-up-shot-of-hopeful-and-optimistic-happy-young-redhead-20s-girl-with-freckles-and-long-hair-smiling-joyfully-with-faith-in-eyes-and-prominent-look-posing-against-purple-background_1258-81590.jpg?size=626&ext=jpg&ga=GA1.2.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Воронин Петр', 
        department: 'Тестировщик',
        id: 16,
        salary: 30000,
        avatar: 'https://img.freepik.com/free-photo/cheerful-young-man-posing-isolated-over-grey_171337-10579.jpg?size=626&ext=jpg&ga=GA1.1.478568990.1689048524&semt=ais',
    },
    {
        userName: 'Иванов Сергей', 
        department: 'Backend разработчик',
        id: 17,
        salary: 100000,
        avatar: 'https://img.freepik.com/free-photo/portrait-of-handsome-serious-man_23-2149022626.jpg?size=626&ext=jpg&ga=GA1.1.478568990.1689048524&semt=ais',
    },
]

export const colors = ['#E6E6FA', '#FFDAB9', '#AFEEEE', '#ADD8E6', '#7FFFD4', '#87CEFA', '#FFDEAD', '#F08080', '#9370DB', '#DDA0DD'];
